import Youtube from './directives/Youtube';

export default angular.module('edge.platform.widgets.youtube', [])
    .directive('gwYoutube', Youtube);